import { RowOptions } from "./tableTypes";

const easternTimeZone = "America/New_York";

function currentEasternTime(): Date {
  return new Date(
    new Date().toLocaleString("en-US", { timeZone: easternTimeZone })
  );
}

/** Whether a row's links should be visible at the current time. */
export function isReleased(row: Pick<RowOptions, "autoReleaseDate">): boolean {
  return (
    row.autoReleaseDate === undefined ||
    currentEasternTime() > new Date(row.autoReleaseDate)
  );
}

/** Whether an assignment is past its due date. */
export function isPastDue(row: Pick<RowOptions, "dueDate">): boolean {
  return row.dueDate !== undefined && currentEasternTime() > new Date(row.dueDate);
}

type ScheduleRow = Pick<RowOptions, "autoReleaseDate" | "dueDate">;

/** The latest released assignment that is still in progress. */
export function isCurrentProject(
  row: ScheduleRow,
  rows: ScheduleRow[]
): boolean {
  if (!isReleased(row) || isPastDue(row) || row.autoReleaseDate === undefined) {
    return false;
  }

  const latest = rows.reduce((max, candidate) => {
    if (
      !isReleased(candidate) ||
      isPastDue(candidate) ||
      candidate.autoReleaseDate === undefined
    ) {
      return max;
    }
    return Math.max(max, new Date(candidate.autoReleaseDate).getTime());
  }, -1);

  return new Date(row.autoReleaseDate).getTime() === latest;
}

/** Returns a copy of a row with all resource links hidden. */
export function hideRowLinks(row: RowOptions): RowOptions {
  const cellNametoLinks = new Map<string, string>();

  row.cellNametoLinks.forEach((_, label) => cellNametoLinks.set(label, ""));

  return { ...row, cellNametoLinks };
}
